import React, { createContext, useContext, useState, useEffect } from 'react';
// TODO: Convert to Supabase (base44Client removed)
import { logger } from '@/lib/logger';
const LanguageContext = createContext();

export const translations = {
  en: {
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    noResults: 'No results found',
    viewAll: 'View All',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    confirm: 'Confirm',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    
    // Navigation & Layout
    home: 'Home',
    notifications: 'Notifications',
    settings: 'Settings',
    profile: 'Profile',
    logout: 'Logout',
    tenants: 'Tenants',
    tenantAdmins: 'Tenant Admins',
    orphanedRecords: 'Orphaned Records',
    platformAnalytics: 'Platform Analytics',
    branches: 'Branches',
    branchAdministrators: 'Branch Administrators',
    tenantSettings: 'Tenant Settings',
    groups: 'Groups',
    teachers: 'Teachers',
    children: 'Children',
    parents: 'Parents',
    menu: 'Menu',
    branchSettings: 'Branch Settings',
    dailyUpdates: 'Daily Updates',
    photos: 'Photos',
    announcements: 'Announcements',
    schedule: 'Schedule',
    myChildren: 'My Children',
    messages: 'Messages',
    weeklyMenu: 'Weekly Menu',
    organization: 'Organization',
    currentBranch: 'Current Branch',
    branch: 'Branch',

    // Role switcher (context switcher)
    switchRole: 'Switch Role',
    switchedToParentView: 'Switched to Parent view',
    switchedToTeacherView: 'Switched to Teacher view',
    switchedToBranchAdminView: 'Switched to Branch Admin view',
    switchedToSuperAdminView: 'Switched to Super Admin view',
    roleSuperAdmin: 'Super Admin',
    roleBranchAdmin: 'Branch Admin',
    roleTeacher: 'Teacher',
    roleParent: 'Parent',
    roleDescriptionPlatformManagement: 'Platform Management',
    roleDescriptionBranchManagement: 'Branch Management',
    roleDescriptionGroupManagement: 'Group Management',
    roleDescriptionChildView: 'Child View',
    activeRole: 'Active Role',
    defaultRole: 'Default',
    
    // Greetings
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    
    // Home Page
    welcomeBack: 'Welcome back',
    childrenRegistered: 'children registered',
    childRegistered: 'child registered',
    managingGroups: 'Managing {count} groups',
    branchAdminDashboard: 'Branch Administrator Dashboard',
    tenantAdminDashboard: 'Tenant Administrator Dashboard',
    platformAdminDashboard: 'Platform Administrator Dashboard',
    
    // Stats
    totalTenants: 'Total Tenants',
    activeTenants: 'Active Tenants',
    revenue: 'Revenue',
    inactive: 'Inactive',
    myGroups: 'My Groups',
    updatedToday: 'Updated Today',
    completion: 'Completion',
    pendingVerifications: 'Pending',
    
    // Actions
    addNew: 'Add New',
    createNew: 'Create New',
    inviteTeacher: 'Invite Teacher',
    addChild: 'Add Child',
    addGroup: 'Add Group',
    addBranch: 'Add Branch',
    markAbsence: 'Mark Absence',
    reportAbsence: 'Report Absence',
    uploadPhoto: 'Upload Photo',
    sendAnnouncement: 'Send Announcement',
    
    // Forms
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    dateOfBirth: 'Date of Birth',
    date: 'Date',
    reason: 'Reason',
    notes: 'Notes',
    description: 'Description',
    name: 'Name',
    title: 'Title',
    message: 'Message',
    content: 'Content',
    
    // Status
    active: 'Active',
    pending: 'Pending',
    verified: 'Verified',
    rejected: 'Rejected',
    present: 'Present',
    absent: 'Absent',
    
    // Settings Page
    profileSettings: 'Profile Settings',
    notificationPreferences: 'Notification Preferences',
    privacyConsent: 'Privacy & Consent',
    language: 'Language',
    selectLanguage: 'Select Language',
    english: 'English',
    polish: 'Polish',
    dailyUpdatesNotif: 'Daily Updates',
    announcementsNotif: 'Announcements',
    photosNotif: 'New Photos',
    privacyPolicy: 'Privacy Policy',
    photoSharing: 'Photo Sharing',
    termsOfService: 'Terms of Service',
    dataExport: 'Export My Data',
    deleteAccount: 'Delete Account',
    saveChanges: 'Save Changes',

    // Dashboard & Stats
    totalBranches: 'Total Branches',
    orphaned: 'Orphaned',
    recentTenants: 'Recent Tenants',
    createTenant: 'Create Tenant',
    editTenant: 'Edit Tenant',
    organizationName: 'Organization Name',
    contactEmail: 'Contact Email',
    contactPhone: 'Contact Phone',
    customPrice: 'Custom Price (PLN/branch/month)',
    overrideDefaultPricing: 'Override default price (Standard: 100, Premium: 200)',
    quickActions: 'Quick Actions',

    // Teachers Page
    inviteNewTeacher: 'Invite New Teacher',
    sendInvitation: 'Send Invitation',
    assignedGroups: 'Assigned Groups',
    noGroupsAssigned: 'No groups assigned',
    removeFromBranch: 'Remove from Branch',
    selectBranch: 'Select Branch',
    
    // Children Page
    childrenManagement: 'Children Management',
    dietaryRestrictions: 'Dietary Restrictions',
    dietaryNotes: 'Dietary Notes',
    verificationStatus: 'Verification Status',
    pendingVerification: 'Pending Verification',
    
    // Groups Page
    groupManagement: 'Group Management',
    mainTeacher: 'Main Teacher',
    assignedTeachers: 'Assigned Teachers',
    childrenCount: 'children',
    
    // Daily Updates
    eating: 'Eating',
    sleep: 'Sleep',
    mood: 'Mood',
    well: 'Well',
    partially: 'Partially',
    poor: 'Poor',
    good: 'Good',
    tired: 'Tired',
    upset: 'Upset',
    ateWell: 'Ate Well',
    sleptWell: 'Slept Well',
    noUpdateYet: 'No update yet today',
    badge: 'Badge',
    todaysUpdate: "Today's Update",

    // Announcements & Messages
    recentNews: 'Recent News',
    newPhotos: 'New Photos',
    noAnnouncements: 'No announcements yet',
    reportIssue: 'Report Issue',
    appProblem: 'App Problem',
    reportToKindergarten: 'Report to Kindergarten',
    sendMessageToTeachers: 'Send message to teachers',
    reportTechnicalIssue: 'Report technical issue',
    regardingChild: 'Regarding Child',
    selectChild: 'Select child',
    subject: 'Subject',
    describeYourConcern: 'Describe your concern or question...',
    messageSentSuccess: 'Message sent to teachers successfully!',
    reportAppProblem: 'Report App Problem',
    describeProblem: 'Describe the problem',
    problemDescription: 'Please describe what happened, what you expected, and any error messages you saw...',
    contactInfoIncluded: 'Your contact information will be included so we can follow up if needed.',
    issueReportedSuccess: 'Issue reported successfully! We will look into it.',
    report: 'Report',
    send: 'Send',
    allCaughtUp: 'All caught up!',
    unreadMessages: 'unread messages',
    markAllRead: 'Mark All Read',
    announcementsFromKindergarten: 'Announcements from kindergarten will appear here',
    new: 'New',
    messageFromParent: 'Message from parent',
    conversations: 'Conversations',
    conversationsWithParents: 'Conversations with Parents',
    replyToParent: 'Reply to Parent',
    replyToTeacher: 'Reply to Teacher',
    yourResponse: 'Your Response',
    writeYourResponse: 'Write your response...',
    conversation: 'Conversation',
    sentAnnouncements: 'Sent Announcements',
    newAnnouncement: 'New Announcement',
    newTemplate: 'New Template',
    sendTo: 'Send To',
    wholeGroup: 'Whole Group',
    selected: 'Selected',
    individual: 'Individual',
    selectGroup: 'Select group',
    selectParents: 'Select Parents',
    quickTemplates: 'Quick Templates',
    createTemplate: 'Create Template',
    templateName: 'Template Name',
    messageTemplate: 'Message Template',
    saveTemplate: 'Save Template',
    noGroupsAssignedToYou: 'No groups assigned to you',
    noMessagesFromParents: 'No messages from parents yet',
    noParentsInGroup: 'No parents in this group',
    noConversationsYet: 'No conversations yet',
    conversationsWithTeachers: 'Your conversations with teachers will appear here',
    replySent: 'Reply sent successfully!',
    teacher: 'Teacher',
    parent: 'Parent',
    you: 'You',
    reply: 'Reply',
    read: 'read',
    
    // Empty States
    noTeachersYet: 'No teachers yet',
    noChildrenYet: 'No children yet',
    noGroupsYet: 'No groups yet',
    noBranchesYet: 'No branches yet',
    noPhotosYet: 'No photos yet',
    
    // Confirmations
    confirmDelete: 'Are you sure you want to delete this?',
    confirmRemove: 'Are you sure you want to remove this?',
    deleteAccountWarning: 'This action cannot be undone. All your data will be permanently deleted.',

    // Success Messages
    invitationSent: 'Invitation sent',
    changesSaved: 'Changes saved',
    absenceReported: 'Absence reported successfully',
    settingsSaved: 'Settings saved successfully!',

    // Errors
    somethingWentWrong: 'Something went wrong',
    tryAgain: 'Please try again',

    // Additional Settings
    manageAccountPreferences: 'Manage your account and preferences',
    yourPersonalInfo: 'Your personal information',
    chooseNotifications: 'Choose what notifications you receive',
    privacyConsents: 'Privacy & Consent (RODO)',
    manageDataConsent: 'Manage your data and consent preferences',
    yourDataRights: 'Your Data Rights',
    rodoBanner: 'Under RODO, you have the right to access, export, and delete your personal data.',
    deleteAccountConfirm: 'Delete Account',
    willDelete: 'This will delete:',
    accountProfileData: 'Your account and profile data',
    allConsentRecords: 'All consent records',
    childrenConnection: "Connection to your children's profiles",
    notificationPrefs: 'Notification preferences',

    // Notifications types
    eatingUpdate: 'Eating, sleeping, mood updates about your child',
    messagesFromTeachers: 'Messages from teachers',
    whenPhotosShared: 'When teachers share new photos',
    weeklyMealChanges: 'Weekly meal plan changes',
    sundayReminders: 'Sunday reminders to report absences',

    // Consent types
    acceptPrivacyPolicy: 'Accept the privacy policy for data handling',
    allowPhotoSharing: 'Allow teachers to share photos of your child',
    acceptTerms: 'Accept the terms and conditions of use',
    },
  
  pl: {
    // Common
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    edit: 'Edytuj',
    add: 'Dodaj',
    create: 'Utwórz',
    update: 'Aktualizuj',
    search: 'Szukaj',
    filter: 'Filtruj',
    loading: 'Ładowanie...',
    noResults: 'Brak wyników',
    viewAll: 'Zobacz wszystko',
    back: 'Wstecz',
    next: 'Dalej',
    submit: 'Wyślij',
    confirm: 'Potwierdź',
    close: 'Zamknij',
    yes: 'Tak',
    no: 'Nie',
    
    // Navigation & Layout
    home: 'Pulpit',
    notifications: 'Powiadomienia',
    settings: 'Ustawienia',
    profile: 'Profil',
    logout: 'Wyloguj',
    tenants: 'Organizacje',
    tenantAdmins: 'Administratorzy organizacji',
    orphanedRecords: 'Osierocone rekordy',
    platformAnalytics: 'Analityka platformy',
    branches: 'Oddziały',
    branchAdministrators: 'Administratorzy oddziałów',
    tenantSettings: 'Ustawienia organizacji',
    groups: 'Grupy',
    teachers: 'Nauczyciele',
    children: 'Dzieci',
    parents: 'Rodzice',
    menu: 'Jadłospis',
    branchSettings: 'Ustawienia placówki',
    dailyUpdates: 'Dziennik',
    photos: 'Zdjęcia',
    announcements: 'Ogłoszenia',
    schedule: 'Harmonogram',
    myChildren: 'Moje dzieci',
    messages: 'Wiadomości',
    weeklyMenu: 'Menu tygodniowe',
    organization: 'Organizacja',
    currentBranch: 'Wybrany oddział',
    branch: 'Oddział',

    // Role switcher (context switcher)
    switchRole: 'Zmień rolę',
    switchedToParentView: 'Przełączono na widok rodzica',
    switchedToTeacherView: 'Przełączono na widok nauczyciela',
    switchedToBranchAdminView: 'Przełączono na widok administratora placówki',
    switchedToSuperAdminView: 'Przełączono na widok Super Admin',
    roleSuperAdmin: 'Super Admin',
    roleBranchAdmin: 'Administrator placówki',
    roleTeacher: 'Nauczyciel',
    roleParent: 'Rodzic',
    roleDescriptionPlatformManagement: 'Zarządzanie platformą',
    roleDescriptionBranchManagement: 'Zarządzanie placówką',
    roleDescriptionGroupManagement: 'Zarządzanie grupami',
    roleDescriptionChildView: 'Widok rodzica',
    activeRole: 'Aktywna rola',
    defaultRole: 'Domyślna',
    
    // Greetings
    goodMorning: 'Dzień dobry',
    goodAfternoon: 'Dzień dobry',
    goodEvening: 'Dobry wieczór',
    
    // Home Page
    welcomeBack: 'Witaj ponownie',
    childrenRegistered: 'dzieci zarejestrowanych',
    childRegistered: 'dziecko zarejestrowane',
    managingGroups: 'Zarządzanie {count} grupami',
    branchAdminDashboard: 'Panel administratora oddziału',
    tenantAdminDashboard: 'Panel administratora organizacji',
    platformAdminDashboard: 'Panel administratora platformy',
    
    // Stats
    totalTenants: 'Wszystkich organizacji',
    activeTenants: 'Aktywnych organizacji',
    revenue: 'Przychód',
    inactive: 'Nieaktywni',
    myGroups: 'Moje grupy',
    updatedToday: 'Zaktualizowane dziś',
    completion: 'Ukończenie',
    pendingVerifications: 'Oczekujące',
    
    // Actions
    addNew: 'Dodaj nowy',
    createNew: 'Utwórz nowy',
    inviteTeacher: 'Zaproś nauczyciela',
    addChild: 'Dodaj dziecko',
    addGroup: 'Dodaj grupę',
    addBranch: 'Dodaj oddział',
    markAbsence: 'Zgłoś nieobecność',
    reportAbsence: 'Zgłoś nieobecność',
    uploadPhoto: 'Prześlij zdjęcie',
    sendAnnouncement: 'Wyślij ogłoszenie',
    
    // Forms
    firstName: 'Imię',
    lastName: 'Nazwisko',
    email: 'Email',
    phone: 'Telefon',
    address: 'Adres',
    dateOfBirth: 'Data urodzenia',
    date: 'Data',
    reason: 'Powód',
    notes: 'Notatki',
    description: 'Opis',
    name: 'Nazwa',
    title: 'Tytuł',
    message: 'Wiadomość',
    content: 'Treść',
    
    // Status
    active: 'Aktywny',
    pending: 'Oczekujący',
    verified: 'Zweryfikowany',
    rejected: 'Odrzucony',
    present: 'Obecny',
    absent: 'Nieobecny',
    
    // Settings Page
    profileSettings: 'Ustawienia profilu',
    notificationPreferences: 'Preferencje powiadomień',
    privacyConsent: 'Prywatność i zgody',
    language: 'Język',
    selectLanguage: 'Wybierz język',
    english: 'Angielski',
    polish: 'Polski',
    dailyUpdatesNotif: 'Dzienne aktualizacje',
    announcementsNotif: 'Ogłoszenia',
    photosNotif: 'Nowe zdjęcia',
    privacyPolicy: 'Polityka prywatności',
    photoSharing: 'Udostępnianie zdjęć',
    termsOfService: 'Regulamin',
    dataExport: 'Eksportuj moje dane',
    deleteAccount: 'Usuń konto',
    saveChanges: 'Zapisz zmiany',

    // Dashboard & Stats
    totalBranches: 'Wszystkie oddziały',
    orphaned: 'Osierocone',
    recentTenants: 'Ostatnie organizacje',
    createTenant: 'Utwórz organizację',
    editTenant: 'Edytuj organizację',
    organizationName: 'Nazwa organizacji',
    contactEmail: 'Email kontaktowy',
    contactPhone: 'Telefon kontaktowy',
    customPrice: 'Cena niestandardowa (PLN/oddział/miesiąc)',
    overrideDefaultPricing: 'Nadpisz domyślną cenę (Standard: 100, Premium: 200)',
    quickActions: 'Szybkie akcje',

    // Teachers Page
    inviteNewTeacher: 'Zaproś nowego nauczyciela',
    sendInvitation: 'Wyślij zaproszenie',
    assignedGroups: 'Przypisane grupy',
    noGroupsAssigned: 'Brak przypisanych grup',
    removeFromBranch: 'Usuń z oddziału',
    selectBranch: 'Wybierz oddział',
    
    // Children Page
    childrenManagement: 'Zarządzanie dziećmi',
    dietaryRestrictions: 'Ograniczenia dietetyczne',
    dietaryNotes: 'Notatki dietetyczne',
    verificationStatus: 'Status weryfikacji',
    pendingVerification: 'Oczekuje na weryfikację',
    
    // Groups Page
    groupManagement: 'Zarządzanie grupami',
    mainTeacher: 'Główny nauczyciel',
    assignedTeachers: 'Przypisani nauczyciele',
    childrenCount: 'dzieci',
    
    // Daily Updates
    eating: 'Jedzenie',
    sleep: 'Sen',
    mood: 'Nastrój',
    well: 'Dobrze',
    partially: 'Częściowo',
    poor: 'Słabo',
    good: 'Dobry',
    tired: 'Zmęczony',
    upset: 'Zdenerwowany',
    ateWell: 'Jadł dobrze',
    sleptWell: 'Spał dobrze',
    noUpdateYet: 'Brak aktualizacji na dziś',
    badge: 'Odznaka',
    todaysUpdate: 'Dzisiejsza aktualizacja',

    // Announcements & Messages
    recentNews: 'Ostatnie wiadomości',
    newPhotos: 'Nowe zdjęcia',
    noAnnouncements: 'Brak ogłoszeń',
    reportIssue: 'Zgłoś problem',
    appProblem: 'Problem z aplikacją',
    reportToKindergarten: 'Zgłoś do przedszkola',
    sendMessageToTeachers: 'Wyślij wiadomość do nauczycieli',
    reportTechnicalIssue: 'Zgłoś problem techniczny',
    regardingChild: 'Dotyczy dziecka',
    selectChild: 'Wybierz dziecko',
    subject: 'Temat',
    describeYourConcern: 'Opisz swoje pytanie lub problem...',
    messageSentSuccess: 'Wiadomość wysłana do nauczycieli!',
    reportAppProblem: 'Zgłoś problem z aplikacją',
    describeProblem: 'Opisz problem',
    problemDescription: 'Opisz co się stało, czego oczekiwałeś i jakie błędy widziałeś...',
    contactInfoIncluded: 'Twoje dane kontaktowe zostaną dołączone, abyśmy mogli się z Tobą skontaktować.',
    issueReportedSuccess: 'Problem zgłoszony! Zajmiemy się tym.',
    report: 'Zgłoś',
    send: 'Wyślij',
    allCaughtUp: 'Wszystko przeczytane!',
    unreadMessages: 'nieprzeczytanych wiadomości',
    markAllRead: 'Oznacz wszystkie jako przeczytane',
    announcementsFromKindergarten: 'Tutaj pojawią się ogłoszenia z przedszkola',
    new: 'Nowe',
    messageFromParent: 'Wiadomość od rodzica',
    conversations: 'Rozmowy',
    conversationsWithParents: 'Rozmowy z rodzicami',
    replyToParent: 'Odpowiedz rodzicowi',
    replyToTeacher: 'Odpowiedz nauczycielowi',
    yourResponse: 'Twoja odpowiedź',
    writeYourResponse: 'Napisz swoją odpowiedź...',
    conversation: 'Rozmowa',
    sentAnnouncements: 'Wysłane ogłoszenia',
    newAnnouncement: 'Nowe ogłoszenie',
    newTemplate: 'Nowy szablon',
    sendTo: 'Wyślij do',
    wholeGroup: 'Cała grupa',
    selected: 'Wybrane',
    individual: 'Indywidualne',
    selectGroup: 'Wybierz grupę',
    selectParents: 'Wybierz rodziców',
    quickTemplates: 'Szybkie szablony',
    createTemplate: 'Utwórz szablon',
    templateName: 'Nazwa szablonu',
    messageTemplate: 'Szablon wiadomości',
    saveTemplate: 'Zapisz szablon',
    noGroupsAssignedToYou: 'Brak przypisanych grup',
    noMessagesFromParents: 'Brak wiadomości od rodziców',
    noParentsInGroup: 'Brak rodziców w tej grupie',
    noConversationsYet: 'Brak rozmów',
    conversationsWithTeachers: 'Twoje rozmowy z nauczycielami pojawią się tutaj',
    replySent: 'Odpowiedź wysłana pomyślnie!',
    teacher: 'Nauczyciel',
    parent: 'Rodzic',
    you: 'Ty',
    reply: 'Odpowiedz',
    read: 'przeczytanych',
    
    // Empty States
    noTeachersYet: 'Brak nauczycieli',
    noChildrenYet: 'Brak dzieci',
    noGroupsYet: 'Brak grup',
    noBranchesYet: 'Brak oddziałów',
    noPhotosYet: 'Brak zdjęć',
    
    // Confirmations
    confirmDelete: 'Czy na pewno chcesz to usunąć?',
    confirmRemove: 'Czy na pewno chcesz to usunąć?',
    deleteAccountWarning: 'Ta akcja jest nieodwracalna. Wszystkie Twoje dane zostaną trwale usunięte.',

    // Success Messages
    invitationSent: 'Zaproszenie wysłane',
    changesSaved: 'Zmiany zapisane',
    absenceReported: 'Nieobecność zgłoszona pomyślnie',
    settingsSaved: 'Ustawienia zapisane pomyślnie!',

    // Errors
    somethingWentWrong: 'Coś poszło nie tak',
    tryAgain: 'Spróbuj ponownie',

    // Additional Settings
    manageAccountPreferences: 'Zarządzaj kontem i preferencjami',
    yourPersonalInfo: 'Twoje dane osobowe',
    chooseNotifications: 'Wybierz jakie powiadomienia otrzymujesz',
    privacyConsents: 'Prywatność i zgody (RODO)',
    manageDataConsent: 'Zarządzaj swoimi danymi i preferencjami zgód',
    yourDataRights: 'Twoje prawa do danych',
    rodoBanner: 'Zgodnie z RODO masz prawo do dostępu, eksportu i usunięcia swoich danych osobowych.',
    deleteAccountConfirm: 'Usuń konto',
    willDelete: 'Zostanie usunięte:',
    accountProfileData: 'Twoje konto i dane profilu',
    allConsentRecords: 'Wszystkie zgody',
    childrenConnection: 'Połączenie z profilami Twoich dzieci',
    notificationPrefs: 'Preferencje powiadomień',

    // Notifications types
    eatingUpdate: 'Jedzenie, sen, nastrój Twojego dziecka',
    messagesFromTeachers: 'Wiadomości od nauczycieli',
    whenPhotosShared: 'Gdy nauczyciele udostępniają nowe zdjęcia',
    weeklyMealChanges: 'Zmiany w tygodniowym jadłospisie',
    sundayReminders: 'Niedzielne przypomnienia o zgłoszeniu nieobecności',

    // Consent types
    acceptPrivacyPolicy: 'Akceptuj politykę prywatności dotyczącą przetwarzania danych',
    allowPhotoSharing: 'Pozwól nauczycielom udostępniać zdjęcia Twojego dziecka',
    acceptTerms: 'Akceptuj warunki korzystania z usługi',
    }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('pl');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLanguage();
  }, []);

  const loadLanguage = async () => {
    try {
      // TODO: Convert to Supabase
      // const user = await base44.auth.me();
      if (user?.language) {
        setLanguage(user.language);
      }
    } catch (e) {
      // Not logged in, use default
    } finally {
      setLoading(false);
    }
  };

  const changeLanguage = async (lang) => {
    setLanguage(lang);
    try {
      // TODO: Convert to Supabase
      // await base44.auth.updateMe({ language: lang });
    } catch (e) {
      logger.error('Failed to save language preference:', e);
    }
  };

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, loading }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}